// extracted by mini-css-extract-plugin
export default {"general":"General_general__jY60u"};